const  textChange = {
    text: document.querySelectorAll('.jsTextHtml') as NodeListOf<HTMLElement>,


   
    init() {
      this.textChange();
      
    },
    textChange() {
        this.text.forEach((item) => {      
            const text =  item.dataset.text as string;
            item.innerHTML = text;
         })
    },
  

}

export default  textChange;